
import { postMessage, addListenMessage } from './message';
import { getParamAdtag, getUrlParam } from './url';
import { debounce, isInMiniProgram } from './util';

let ready = false;
let adtagVal = '';
let noAdtag = false;
const noAdtagTransferTag = 'noAdtagTransfer';


export function setNoNeedAdtag(){
  noAdtag = true
}

function _isNeetAdtag() {
  return +getUrlParam(noAdtagTransferTag) !== 1 && !noAdtag && !isInMiniProgram();
}


function listenMessage() {
  addListenMessage().then((eData) => {
    const type = eData.type;
    if (type === 'get_adtag') {
      adtagVal = eData.tag || '';
      ready = true;
    }
  });
}

function postRegisterMessage() {
  postMessage({
    type: 'register_adtag',
    tag: getParamAdtag()
  });
}

export function adtagInit() {
  if(!_isNeetAdtag()){
    return true;
  }
  listenMessage();
  postRegisterMessage();
}

export function getAdtag() {
  return adtagVal;
}

let adtagPromise
export function checkAdtagReady() {
  if(!_isNeetAdtag()){
    // 如果不需要iframe加载adtag，就直接返回
    return Promise.resolve(true);
  }
  if (!adtagPromise) {
    adtagPromise = new Promise((res, rej) => {
      debounce(()=>ready, 0, 15, res, res); //注意，这里失败情况，也resolve出去，大不了没有adtag了
    });
  }
  return adtagPromise;
}
